const Dnb = () => {
    return (
        <div>
        <script language="JavaScript" src="http://dunsregistered.dnb.com" type="text/javascript"></script>
        </div>
    );
    }
export default Dnb;